// extracted by mini-css-extract-plugin
export default {"container":"MainDetails_container__IyLQv","row":"MainDetails_row__5O5M5","col":"MainDetails_col__wXs1q"};